<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Уровни</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Поиск"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="pollTemplatesData"
                :rows-per-page-items="[10,25,50,100]"
                class="elevation-1"
                item-key="Id"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.Id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.extId }}</td>
                  <td>
                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      @click="editOpen(props.item)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="pink"
                      small
                      @click="removeItemConfirm(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->

              <div slot="widget-content">
                <v-dialog v-model="popupEdit.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">Редактирование</span>
                      <span class="headline" v-if="editedIndex === -1">Добавление</span>
                    </v-card-title>
                    <div style="overflow-y: scroll; height: 700px; width: 100%;">
                      <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <!-- ID анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>ID анкеты</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <span v-if="readonlyFields">{{modalData.Id}}</span>
                              <v-text-field
                                v-if="!readonlyFields"
                                label="ID анкеты"
                                v-model="modalData.Id"
                                type="number"
                                :rules="rules.Id"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Внешний ключ для анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Внешний ключ для анкеты</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <span v-if="readonlyFields">{{modalData.extId}}</span>
                              <v-text-field
                                v-if="!readonlyFields"
                                label="Внешний ключ для анкеты"
                                v-model="modalData.extId"
                                :rules="rules.extId"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Код сценария визита -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Код сценария визита</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Код сценария визита"
                                v-model="modalData.visitTypeId"
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Наименование анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Наименование анкеты</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Наименование анкеты"
                                v-model="modalData.name"
                                :rules="rules.required"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Признак группы -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Признак группы</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-checkbox label="Признак группы" v-model="modalData.isGroup"></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <!-- Код группы -->
                          <v-layout
                            row
                            v-show="modalData.isGroup || (modalData.parentId !== null && modalData.parentId !== '')"
                          >
                            <v-flex xs4>
                              <v-subheader>Код группы</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Код группы"
                                v-model="modalData.parentId"
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Код предшествующей анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Код предшествующей анкеты</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Код предшествующей анкеты"
                                v-model="modalData.requiredId"
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Ключ сортировки -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Ключ сортировки</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Ключ сортировки"
                                v-model="modalData.orderKey"
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Обязательность заполнения -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Обязательнa для заполнения</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-checkbox label="Обязательнa" v-model="modalData.isRequired"></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <!-- Количество дней до возможности повтора -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Количество дней до возможности повтора</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field
                                label="Количество дней"
                                v-model="modalData.timeToRepeat"
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Вопрос в зачет -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Вопрос в зачет</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-select
                                v-model.lazy="modalData.requiredQuestId"
                                :items="answerList"
                                label="Вопрос в зачет"
                              ></v-select>
                            </v-flex>
                          </v-layout>

                          <!-- Фильтр анкеты для предыдущей анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Фильтр</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-select
                                v-model.lazy="modalData.requiredSearchMode"
                                :items="filterList"
                                label="Фильтр"
                                persistent-hint
                                hint="Как мы фильтруем анкеты для предыдущей анкеты"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-card-text>
                    </div>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить уровень?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click.native="popupRemove.isOpen = false"
                      >Отмена</v-btn>
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click.native="actionRemove(modalData);"
                      >Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from "vuetify/es5/util/colors";
import Util from "@/util";

export default {
  components: {},
  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      colors,
      filterList: [
        {
          text: "По клинике и стоматологу",
          value: 0
        },
        {
          text: "По стоматологу",
          value: 1
        },
        {
          text: "По клинике",
          value: 2
        }
      ],
      rules: {
        required: [v => !!v || "Обязательное поле"],
        extId: [
          v => !!v || "Ключ не может быть пустым",
          v => v.split(" ").length === 1 || "Нельзя использовать пробелы",
          v =>
            this.pollTemplatesData.filter(el => el.extId === v).length === 0 ||
            "Такой ключ уже существует"
        ],
        Id: [
          v => !!v || "ID не может быть пустым",
          v =>
            this.pollTemplatesData.filter(el => el.Id === v).length === 0 ||
            "Такой ID уже существует"
        ]
      },
      search: "",
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false
      },
      complex: {
        selected: [],
        headers: [
          {
            text: "ID анкеты",
            value: "Id"
          },
          {
            text: "Название анкеты",
            value: "name"
          },
          {
            text: "Ключ",
            value: "extId"
          },
          {
            text: "Действия",
            value: ""
          }
        ]
      }
    };
  },

  mounted: function() {
    /**
     * Загружаем данные по анкетам при первой отрисовке страницы, если pollTemplatesData не пустой, то не обновляемся
     */
    if (this.pollTemplatesData.length === 0) {
      this.refresh();
    }

    /**
     * Загружаем данные по вопросам анкеты, если pollQuestsData не пустой, то не обновляемся
     */
    if (this.$store.getters["pollQuests/pollQuestsData"].length === 0) {
      this.$store._actions["pollQuests/getPollQuestsData"][0]();
    }
  },

  computed: {
    /**
     * Данные по уровням
     * @returns {default.computed.pollTemplatesData|(function())|Array|getters.pollTemplatesData}
     */
    pollTemplatesData() {
      return this.$store.getters["pollTemplates/pollTemplatesData"];
    },

    /**
     * Список вопросов для Select'а ри выборе обязательного вопроса
     */
    answerList() {
      return this.$store.getters["pollQuests/pollQuestsData"]
        .filter(pqd => pqd.pollId === this.modalData.Id)
        .map(_pqd => {
          return {
            text: _pqd.name,
            value: _pqd.Id
          };
        });
    }
  },

  methods: {
    /**
     * Обновление данных по уровням
     */
    refresh() {
      this.$store._actions["pollTemplates/getPollTemplatesData"][0]();
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // // Если редактирование
      // if (item !== null && typeof item !== "undefined") {
      //   this.modalData = item;
      //   this.oldModalData = Object.assign({}, item);
      //   this.editedIndex = this.pollTemplatesData.indexOf(item);
      //   this.readonlyFields = true;
      //   // Если добавление
      // } else {
      //   let maxId = Math.max.apply(
      //     null,
      //     this.pollTemplatesData.map(poll => {
      //       return poll.Id;
      //     })
      //   );
      //   this.modalData = {
      //     Id: maxId + 1,
      //     visitTypeId: null,
      //     name: "",
      //     extId: "",
      //     isGroup: false,
      //     parentId: null,
      //     requiredId: null,
      //     orderKey: null,
      //     isRequired: false,
      //     timeToRepeat: null,
      //     requiredQuestId: null,
      //     requiredSearchMode: 0
      //   };
      //   this.oldModalData = {};
      //   this.editedIndex = -1;
      //   this.readonlyFields = false;
      // }
      // this.popupEdit.isOpen = true;
      window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Функция добавления или редактирования в настоящий момент недоступна!');
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(
          this.pollTemplatesData[this.editedIndex],
          this.oldModalData
        );
      }
      this.popupEdit.isOpen = false;
    },

    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.$store._actions["pollTemplates/savePollTemplatesData"]
          [0]({ index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.popupEdit.isOpen = false;
          });
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Функция удаления в настоящий момент недоступна!');
      // this.popupRemove.isOpen = true;
      // this.modalData = data;
    },

    /**
     * Удаление элемента
     * @param item
     */
    actionRemove(item) {
      window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Функция удаления в настоящий момент недоступна!');
      // this.$store._actions["pollTemplates/removePollTemplatesData"][0]({
      //   item: item
      // });
      this.popupRemove.isOpen = false;
    }
  }
};
</script>

<style>
.v-chip__content {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/ui/PollTemplates.vue